<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container fluid v-if="relatedArticleList && relatedArticleList.length > 0">
        <b-row class="mt-5">
            <b-col class="text-center">
                <h3 class="center-line">FIND ME ALSO IN
                    <hr/>
                </h3>
                <b-row align-h="center">
                    <b-col>
                        <pb-carousel>
                            <router-link class="card-deck my-3 mr-3" :key="article.pageId"
                                         v-for="(article) in relatedArticleList"
                                         :to="{ name: 'theme', params : {season : article.season, sub: article.parentId}, hash: '#' + article.pageId}">
                                <pb-card class="related-article-card"
                                         :img-src="article.thumbnail">
                                    <template slot="content">
                                    </template>
                                </pb-card>
                            </router-link>
                        </pb-carousel>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import {mapState} from "vuex";
    import ContentAPI from "../../../../../shared/_api/cms/content";
    import * as _ from "lodash";

    export default {
        name: 'pb-related-moods',
        data: function () {
            return {
                relatedArticleList: [],
                collectionMoodIdMap: new Map()
            }
        },
        mounted() {
            Promise.all([ContentAPI.fetchListByName("design-shop"), ContentAPI.fetchListByName("collection_moods")]).then(([designShopList, collectionMoodList]) => {
                collectionMoodList.forEach((collectionMoodPage) => {
                    this.collectionMoodIdMap.set(collectionMoodPage.id, collectionMoodPage);
                });

                designShopList.forEach((designShopPage) => {
                    this.parseArticles(designShopPage)
                });

                this.relatedArticleList = _.uniqBy(this.relatedArticleList, 'pageId');
            });
        },
        methods: {
            parseArticles(page, parent, season) {
                let isActive = page.visibility ? page.visibility.value : true;

                if (isActive && page.tile) {
                    let tile = page.tile.value;

                    if (tile) {

                        if (!_.isEmpty(tile.pinList)) {
                            tile.pinList.forEach((pin) => {
                                if (!_.isEmpty(pin.articleList)) {
                                    pin.articleList.forEach((article) => {
                                        if (article.id === this.article.id) {
                                            this.relatedArticleList.push({
                                                thumbnail: tile.image,
                                                season: season ? season : tile.season,
                                                articleId: article.id,
                                                pageId: page.id,
                                                parentId: parent
                                            });
                                        }
                                    });
                                }
                            });

                            let collectionMoods = page.collection_mood ? page.collection_mood.value : [];

                            if(!_.isEmpty(collectionMoods)) {
                                collectionMoods.forEach((collectionMoodPage) => {
                                    if(this.collectionMoodIdMap.has(collectionMoodPage.id)) {
                                        this.parseArticles(this.collectionMoodIdMap.get(collectionMoodPage.id), page.id, tile.season);
                                    }
                                });
                            }
                        }
                    }
                }
            }
        },
        computed: {
            ...mapState("account", ['user'])
        },
        props: {
            id: {
                type: String
            },
            article: {
                type: Object
            },
            category: {
                type: Object
            }
        }
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .related-article-card {
        width: 275px;
    }

    .tns-ovh {
        padding: 20px 0 !important;
    }

</style>
